const exportToCSV = () => {
    let getType = (type) => {
        if (type == "date") {
            return "date";
        } else {
            return "text"
        }
    }
    let getValue = (data, key, type) => {
        if (key == "organization") {
            let node = data[key + "_node"];
            return node && node["name"] ? node["name"] : "";
        }
        else if (key == "contact") {
            let node = data[key + "_node"];
            return node && node["Firstname"] + " " + node["Lastname"];
        }
        else if (type == "dropdown" || type == "dropdown2") {
            let node = data[key + "_node"];
            return node ? node[key + "_name"] : "";
        } else if (typeof data[key] == 'string' && data[key].lastIndexOf('"') === data[key].length - 1) {
            return data[key] + ' '
        } else {
            return data[key]
        }
    }
    let findControl = (key, controls) => {
        var _control;
        controls.forEach(control => {
            if (control.haschildren == true) {
                _control = findChildControl(key, control);
            }
            else {
                _control = control;
            }
        })
        return _control;
    }
    let findChildControl = (key, control) => {
        if (control.haschildren == true) {
            for (let child of control.children) {
                if (child.key == key) {
                    return child;
                }
                if (child.haschildren == true) {
                    var _child = findChildControl(key, child);
                    if (_child)
                        return _child;
                }
            }
        }
        else if (control.key == key) {
            return control;
        }
    }
    let exporttoCSV = (ExportList, columns, ReportName, columnsStr) => {
        let exprtcsv = [];
        var num = 1;
        JSON.parse(JSON.stringify(ExportList)).forEach(x => {
            var obj = new Object();
            // var frmt = new format();

            columns.forEach(column => {
                if (column.prop == 'sno') {
                    x[column.name] = String(num);
                    num = num + 1;
                }
                // let transfrmVal = frmt.transform(x[column.name], column.type);
                obj[column.prop] = x[column.name] ? String(x[column.name]) : ''; // transfrmVal;
            });
            exprtcsv.push(obj);
        });
        
        downloadcsv(exprtcsv, ReportName, columnsStr);
    }
    let downloadcsv = (data, exportFileName, columnsStr) => {
        var csvData = convertToCSV(data, columnsStr);

        var blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, createFileName(exportFileName))
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", createFileName(exportFileName));
                //link.style = "visibility:hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    let convertToCSV = (objarray, columnsStr) => {

        var array = typeof objarray != 'object' ? JSON.parse(objarray) : objarray;

        var str = '';
        var row = "";

        for (let index in objarray[0]) {
            //Now convert each value to string and comma-separated
            row += index + ',';
        }
        // row = row.slice(0, -1);
        //append Label row with line break
        row = columnsStr;
        str += row + '\r\n';

        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (let index in array[i]) {
                if (line != '') line += ','
                line += JSON.stringify(array[i][index]);
            }
            str += line + '\r\n';
        }

        return str;
    }

    let createFileName = (exportFileName) => {
        var date = new Date();
        return (exportFileName +
            date.toLocaleDateString() + "_" +
            date.toLocaleTimeString()
            + '.csv')
    }
    return {
        generatecsvReport: (columns, data, ReportName) => {
            var columnsStr = "";
            var ExportColumns = [];
            var ExportList = [];

            columns.forEach(item => {
                var exportColumn = { name: "", prop: "", type: "" }

                exportColumn.name = item.name;//control.placeholder;
                exportColumn.prop = item.prop;
                exportColumn.type = item.type;
                ExportColumns.push(exportColumn);
                if (columnsStr == "")
                    columnsStr = exportColumn.name;
                else
                    columnsStr = columnsStr + "," + exportColumn.name;
            });

            data.forEach(item => {
                var row = {};
                ExportColumns.forEach(column => {
                    row[column.name] = getValue(item, column.prop, column.type);
                });
                ExportList.push(row);

            });
            if (ReportName != "Template") {
                ExportColumns.unshift({ name: "S.No.", prop: "sno", type: "text" });
                columnsStr = "S.No.," + columnsStr;
            }
            exporttoCSV(ExportList, ExportColumns, ReportName, columnsStr);
        },
        generateReport: (controls, columns, data, ReportName) => {
            var columnsStr = "";
            var ExportColumns = [];
            var ExportList = [];
            controls = controls.filter(x => x.filterresult != true);
            columns.forEach(item => {
                var exportColumn = { name: "", prop: "", type: "", controlType: "" }
                var control = findControl(item, controls)
                exportColumn.name = control.placeholder;
                exportColumn.prop = item;
                exportColumn.type = getType(control.type);
                exportColumn.controlType = control.type;

                ExportColumns.push(exportColumn);
                if (columnsStr == "")
                    columnsStr = exportColumn.name;
                else
                    columnsStr = columnsStr + ", " + exportColumn.name;
            });

            data.forEach(item => {
                var row = {};
                ExportColumns.forEach(column => {
                    row[column.prop] = getValue(item, column.prop, column.controlType);
                });
                ExportList.push(row);
            });
            if (ReportName != "Template") {
                ExportColumns.unshift({ name: "S.No.", prop: "sno", type: "text", controlType: "" });
                columnsStr = "S.No., " + columnsStr;
            }
            exporttoCSV(ExportList, ExportColumns, ReportName, columnsStr);
        }
    }
}

export default exportToCSV;